import { postPaymentClear, prePaymentClear, prePaymentRecurring } from "@/mock-api/data/billingAccountExample.ts";
import { defaultBillingAccountId } from "@/mock-api/data/billingAccountIds.ts";
import { defaultStorageAccountUuid } from "@/mock-api/data/storageExample.ts";
import type { BillingAccount, Bucket } from "@warrenio/api-spec/spec.oats.gen";

export const demoBillingAccountsExample: BillingAccount[] = [postPaymentClear, prePaymentClear, prePaymentRecurring];

export const demoStorageList: Bucket[] = [
    {
        storage_account_uuid: defaultStorageAccountUuid,
        name: "my-bucket",
        size_bytes: 63612865,
        billing_account_id: defaultBillingAccountId,
        num_objects: 182,
        created_at: "2022-03-04T09:58:29.294+0000",
        modified_at: "2024-01-26T15:26:16.426+0000",
    },
];
